var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 9,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#arrow-up_svg__a)",
    d: "M12.701 8.6 7.493 3.297 2.285 8.6a1.32 1.32 0 0 1-1.892 0 1.379 1.379 0 0 1 0-1.927L6.553.4a1.32 1.32 0 0 1 1.893 0l6.161 6.273a1.379 1.379 0 0 1 0 1.927 1.348 1.348 0 0 1-1.906 0Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "arrow-up_svg__a",
    x1: 0,
    x2: 0.781,
    y1: 9,
    y2: -1.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E61ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9662DB"
  })))));
};
export default SvgArrowUp;